/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { state_update } from "../../App/actions/sini_v2";

/*PICTURE*/

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";

/*DATA*/
import dict from "../../Data/dict.json";
import { parseLatLon } from "../../App/validation/coordinates_validation";
import { Place } from "@material-ui/icons";

/*CONST*/

class SEARCH_LOCATION extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  on_fly_to = ({ geometry, bbox }) => {
    this.props.state_update();
    this.props.set_value_properties({
      key: "modal_input",
      value: false,
    });
    this.props.set_value_properties({
      key: "search_geometry",
      value: geometry,
    });
    this.props.set_value_properties({
      key: "uuid_search",
      value: generate_uuid(),
    });
    const { map_object } = this.props.layer;

    if (map_object) {
      if (geometry.type === "Point") {
        map_object.flyTo({
          center: geometry.coordinates,
          zoom: 13,
        });
      }
      else {
        const [south, north, west, east] = bbox.map(Number);
        map_object.fitBounds(
          [
            [west, south],
            [east, north],
          ],
          {
            padding: 200,
          }
        );
      }

    }

  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { location_result_list, search_input } = this.props.properties;

    const lat_lon = parseLatLon(search_input);
    let feature_by_lat_lon = null
    if (lat_lon) {
      const { lat, lon } = lat_lon;
      feature_by_lat_lon = {
        "coordinates": [lon, lat],
        "type": "Point"
      }
    }

    //content
    return (
      <main>
        <p className="text_small">
          {dict?.["Search for locations by name/coordinates (latitude, longitude)"]?.[language]}
        </p>
        {!lat_lon && location_result_list.length === 0 && !!search_input && (
          <p className="text_medium">{dict?.["No result"]?.[language]}</p>
        )}
        {location_result_list.length > 0 && (
          <section>
            <span className="button_pill_small background_black margin_right inline">
              {lat_lon ? location_result_list.length + 1 : location_result_list.length}
            </span>
            <p className="text_medium inline">{dict?.["Result"]?.[language]}</p>
          </section>
        )}
        <section
          style={{
            overflowY: "auto",
            height: "500px",
            maxHeight: "calc((100vh - 300px))",
            marginTop: "20px",
          }}
        >
          {lat_lon &&
            <main
              className="button_white margin_bottom cursor_pointer"
              onClick={() => this.on_fly_to({ geometry: feature_by_lat_lon })}
            >
              <p className="text_bold margin_bottom"><Place style={{ height: "16px" }} />{`latitude: ${lat_lon.lat}, longitude: ${lat_lon.lon}`}</p>
              <br />
            </main>
          }
          {location_result_list.map((feature, idx) => {
            return (
              <main
                key={idx}
                className="button_white margin_bottom cursor_pointer"
                onClick={() => this.on_fly_to({ geometry: { ...feature?.geojson, center: { long: feature.lon, lat: feature.lat } }, bbox: feature.boundingbox })}
              >
                <p className="text_bold margin_bottom">{feature?.display_name}</p>
                <br />
              </main>
            );
          })}
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  map: state.map,
  properties: state.properties,
});

export default connect(mapStateToProps, { set_value_properties, state_update })(
  SEARCH_LOCATION
);
